import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../application/config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useSelector } from 'react-redux';
import { useEffect,useState } from 'react';
import './Form.css';
import sleep from "sleep-promise";

function Form() {
    const { id } = useParams();
    const [form,setForm] = useState();
    const [formContent,setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;
    const path = 'governanceroom/secretariats';
    const session = useSelector((state) => { return state.session });
    const userSession = session.userSession;

    const paths = {
        endpointSave: `${endpointBackend}${path}/save`,
        endpointGetById: `${endpointBackend}${path}/getById`,
        urlGoBack: `/${path}/list`,
        pathView: `/${path}/view`
    }

    const labels = {
        labelTitleAdd: "Nova Secretaria",
        labelTitleEdit: "Editar Secretaria",
        labelTitleView: 'Visualizar Secretaria'
    }

    let hiddenValues = {};

    if(userSession.loggedUserInfo.application_instance_id){
        hiddenValues = {core_application_instance_id: userSession.loggedUserInfo.application_instance_id}
    }

    const getForm = (values) => {

        let form = {
            validateOnChange: false,
            hiddenValues: {
                core_user_id: userSession.user.id
            },
            fields: [   
                {
                    name: 'governance_room_client_city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                      endpoint: endpointBackend + 'governanceroom/clientscities/getall',
                      label: 'company_city_name',
                      value: 'id',
                      params: {
                        filter: {
                            ...hiddenValues
                        }
                      }
                    },
                    validations: {
                      required: true
                    },
                    columnSize: 12
                  },
                {
                    name: 'title_secretariat',
                    type: 'text',
                    label: 'Nome Secretaria',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }   
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById,{id:id})
            }
            const form = getForm(values);
            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    },[])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
